export enum ReceiptTransactionDate {
    OrderDeliveryDate = '0',
    PurchaseOrderCompletionDate = '1'
  }
  
export const receiptTransactionsDate = Object.keys(ReceiptTransactionDate)
  .filter(key => isNaN(Number(key)))
  .map(key => ({ key: ReceiptTransactionDate[key as keyof typeof ReceiptTransactionDate], value: key }));